// extracted by mini-css-extract-plugin
module.exports = {"imageContainer":"content-image_imageContainer__5Q8RO"};